module.exports = __webpack_public_path__ + "img/btn.97f24071.png";